import React, {
  PropTypes,
  Component,
} from 'react'

import {
  Form,
  message,
  Input,
} from 'antd'

const { TextArea } = Input
// import logo from '../../icon_deknerd.svg'
// import downloadAppStore from '../../download_appstore.svg'
// import downloadGooglePlay from '../../download_google_play.svg'

class footer extends Component {

  static propTypes = {
    loadHandleSendContact: PropTypes.func.isRequired,
    responseStatus: PropTypes.string,
    form: PropTypes.shape({
      validateFieldsAndScroll: PropTypes.func.isRequired,
      resetFields: PropTypes.func,
    }),
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.loadHandleSendContact(values)
        this.props.form.resetFields()
      }
    })
  }

  success = () => {
    message.success('เราได้รับการติดต่อจากคุณแล้ว จะดำเนินการต่อไป')
  }

  error = () => {
    message.error('เกิดปัญหาในการส่งข้อมูล')
  }

  checkError = (responseStatus) => {
    if (+responseStatus === 200 && responseStatus !== '') {
      return (
        message.success('ข้อมูลถูกส่งถึงเราเรียบร้อยแล้ว')
      )
    } else if (+responseStatus !== 200 && responseStatus !== '') {
      return (
        message.error('เกิดปัญหาในการส่งข้อมูล')

      )
    }
    return ''
  }

  render () {
    const { form: {
      getFieldDecorator },
      responseStatus,
    } = this.props
    return (
      <footer>
        {
          this.checkError(responseStatus)
        }
        <div className="grid-row">
          <div className="grid-col-row clear-fix">
            <section className="grid-col grid-col-4 footer-about">
              <h2 className="corner-radius" style={{ backgroundColor: '#f27c65' }}>เกี่ยวกับเรา</h2>
              <address>
                <p />
                <a className="phone-number" >02-392-5005</a>
                <br />
                <a className="site">www.deknerd.com</a>
                <br />
                <a className="address">1000/9-10 ชั้น 18 อาคารลิเบอร์ตี้พลาซ่า <br /> ซอยทองหล่อ ถนนสุขุมวิท 55 แขวงคลองตันเหนือ <br /> เขตวัฒนา กทม. 10110</a>
              </address>
              {/* <div className="footer-social" style={{ textAlign: 'center' }}>
                <a href="https://www.facebook.com/deknerdclub" className="fa fa-facebook" dangerouslySetInnerHTML={{ __html: '' }} />
              </div> */}
            </section>
            <section className="grid-col grid-col-4 footer-about">
              <h2 className="corner-radius" style={{ backgroundColor: '#f9cb8f' }}>เมนูลัด</h2>
              <address>
                <p />
                {/* <a href="/course">เรียนออนไลน์</a> */}
                {/* <br /> */}
                <a href="/etestingHome">คลังข้อสอบ</a>
                <br />
                <a href="/live">ติว TCAS 9 วิชา ฟรี</a>
                {/* <br />
                {/* <a href="/courseOneByOne">เรียนสดตัวต่อตัว</a> */}
                {/* <br /> */}
                {/* <a href="/creators"> ติวเตอร์ทั้งหมดของเรา</a> */}
                {/* <br /> */}
                {/* <a href="/instructor"> ขั้นตอนการสมัครเป็นติวเตอร์</a> */}
              </address>
            </section>
            <section className="grid-col grid-col-4 footer-contact-form" style={{ float: 'right' }}>
              <h2 className="corner-radius">ติดต่อเรา</h2>
              <div className="email_server_responce" />
              <Form className="contact-form" onSubmit={this.handleSubmit}>
                <p>
                  <span className="your-name">
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: 'กรุณาระบุชื่อจริง' }],
                    })(
                      <Input type="text" placeholder="ชื่อ - นามสกุล" />
                    )}
                  </span>
                </p>
                <p>
                  <span className="your-email">
                    {getFieldDecorator('email', {
                      rules: [{ required: true, message: 'กรุณาระบุอีเมลล์ติดต่อกลับ' }],
                    })(
                      <Input type="email" placeholder="อีเมลล์สำหรับติดต่อกลับ" />
                    )}
                  </span>
                </p>
                <p>
                  <span className="your-message">
                    {getFieldDecorator('text', {
                      rules: [{ required: true, message: 'กรุณาระบุรายละเอียดที่ต้องการติดต่อ' }],
                    })(
                      <TextArea placeholder="รายละเอียดที่ต้องการติดต่อ" autosize={{ minRows: 3 }} />
                    )}
                  </span>
                </p>
                <button type="submit" className="cws-button bt-color-3 border-radius alt icon-right">
                  ส่งข้อมูล
                </button>
              </Form>
              {/* <Row>
                <Col span={6} offset={9}>
                  <img alt="deknerd" src={logo} style={{ width: '100%' }} />
                </Col>
              </Row>
              <Row type="flex">
                <Col
                  lg={{ span: 14, offset: 5 }}
                  md={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                  xs={{ span: 20, offset: 2 }}
                  style={{ fontSize: '1.25em', lineHeight: '2', color: '#fff', textAlign: 'center' }}
                >
                  knowledge for sharing
                </Col>
              </Row>
              <Row type="flex">
                <Col
                  lg={{ span: 14, offset: 5 }}
                  md={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                  xs={{ span: 14, offset: 5 }}
                  style={{ fontSize: '1.25em', lineHeight: '2', color: '#fff', textAlign: 'center' }}
                >
                  ใครๆ ก็แชร์ได้
                </Col>
              </Row> */}
              {/* <Row>
                <Col span={10} offset={7}>
                  <img alt="deknerd" src={downloadAppStore} style={{ width: '100%', marginTop: '16px' }} />
                </Col>
              </Row>
              <Row>
                <Col span={10} offset={7}>
                  <img alt="deknerd" src={downloadGooglePlay} style={{ width: '100%', marginTop: '16px' }} />
                </Col>
              </Row> */}
            </section>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="grid-row clear-fix">
            <div className="copyright">DekNerd<span /> 2017 . All Rights Reserved</div>
            <nav className="footer-nav">
              <ul className="clear-fix">
                <li>
                  <a href="/termOfUse">ข้อตกลง</a>
                </li>
                <li>
                  <a href="/policy">นโยบาย</a>
                </li>
                <li>
                  <a href="/privacy">ความเป็นส่วนตัว</a>
                </li>
                <li>
                  <a >ติดต่อเรา</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </footer>
    )
  }
}

export default footer



// WEBPACK FOOTER //
// ./src/components/layouts/footer.js